<template>
  <div class="lab-report-entry-page">

    <!-- Header Card -->
        <PageHeader icon="fas fa-file-medical-alt">
      <template #title>
        Input Hasil Pemeriksaan Laboratorium
      </template>
      <template #subtitle>
        Lengkapi data pasien, pemeriksaan, hasil, dan lampiran berkas lab
      </template>
    </PageHeader>

    <Form
      :form="form"
      purpose="add"
      route="2-lab-reports"
    />

  </div>
</template>

<script>


import Form from '@/component/lab-reports-2/Form.vue'
import Card from '@/view/content/Card.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: '',
        patient_id: '',
        doctor_id: '',
        lab_template_id: '',
        report: '',
        lab_category_id: '',
        attachment: [],
        display_attachment: [],
        removed_attachment: [],
        workflow_status: 'final'
      },
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pemeriksaan Lab" },
      { title: "Input Hasil" },
    ])
  },

}
</script>

<style lang="scss" src="@/assets/sass/pages/_lab-report-entry-page.scss"></style>
